<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

body {
  padding: 0 0;
  margin: 0 0;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.hidden {
  display: none;
}
</style>
